
import { useEffect, useState } from "react";

function TableZoomAble({ children }) {
  const [zoom, setZoom] = useState(1);

  const handleZoomIn = () => {
    setZoom(prevZoom => Math.min(prevZoom + 0.1, 2.5));
  };

  const handleZoomOut = () => {
    setZoom(prevZoom => Math.max(prevZoom - 0.1, 0.2));
  };

  const resetZoom = () => {
    setZoom(1);
  };

  useEffect(() => {
    const handleWheel = (e) => {
      if (e.ctrlKey) {
        e.preventDefault();
        if (e.deltaY < 0) {
          handleZoomIn();
        } else {
          handleZoomOut();
        }
      }
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    return () => window.removeEventListener('wheel', handleWheel);
  }, []);

  return (
    <>
      <div className="absolute top-[92px] tab-max:top-28 left-1/2 -translate-x-1/2 z-20 flex items-center space-x-2 bg-black/50 bg-opacity-70 rounded-md p-2 border border-neutral-700">
        <button
          onClick={handleZoomOut}
          className="text-white text-lg font-bold px-2 py-1 hover:bg-neutral-700 rounded"
        >
          -
        </button>
        <span className="text-white px-2">{(zoom * 100).toFixed(0)}%</span>
        <button
          onClick={handleZoomIn}
          className="text-white text-lg font-bold px-2 py-1 hover:bg-neutral-700 rounded"
        >
          +
        </button>
        <button
          onClick={resetZoom}
          className="text-white text-sm px-2 py-1 hover:bg-neutral-700 rounded"
        >
          Reset
        </button>
      </div>
      <div className="w-[1200px] h-[1000px] bg-zinc-800 relative origin-top-left"
        style={{
          transform: `scale(${zoom})`,
          transformOrigin: 'top left',
          transition: 'transform 0.2s ease-out'
        }}
      >
        {children}
      </div>
    </>
  );
}

export default TableZoomAble;
